export default __webpack_public_path__ + "static/media/36I-102705_-17092_0.7a586c9e.jpg";